import { Suspense, lazy } from 'react';

const Teams = lazy(() => import('../components/Teams/TeamsOverview'));

const TeamsLazy: React.FC = () => {
    return <Suspense><Teams/></Suspense>;
}

export default TeamsLazy;